export default __webpack_public_path__ + "static/media/CommonTensileTableImg.f9585400.jpg";